import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getOrderName } from "./fulfillment-group-csv-utils";

export function getOrderNamesIds(
  row: FulfillmentGroupData,
): Record<string, { id: string } | { redoOrderId: string }> {
  if (!row.orders || !Array.isArray(row.orders)) {
    return {};
  }
  return row.orders.reduce(
    (acc, order) => {
      if (order.name) {
        acc[order.name] = order.redoOrderId
          ? { redoOrderId: order.redoOrderId }
          : { id: order.id };
      }
      return acc;
    },
    {} as Record<string, { id: string } | { redoOrderId: string }>,
  );
}

export const OrderNameCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Order",
    cell: (row) => {
      const orderNamesIds = getOrderNamesIds(row);
      if (Object.values(orderNamesIds).length) {
        return Object.keys(orderNamesIds).join(", ");
      }
      return getOrderName(row);
    },
  };
